<footer class="footer-default grid h-[60px] w-full grid-cols-2">
  <section class="col-span-1">
    <label class="text-inline font-semibold"
      >Sql Report Dashboard - By
      <a
        href="https://t.me/luis122448"
        target="_blank"
        class="hover:underline text-sky-600 dark:text-sky-500 font-bold"
        >luis122448</a
      >
    </label>
    <br />
    <label class="text-inline font-semibold">All rights reserved</label>
  </section>
  <section class="flex flex-row space-x-4 h-full items-center">
    <span
      class="my-auto text-md text-slate-800 dark:text-gray-400 font-semibold"
      >Stack
      <span class="lg:inline">Tech :</span>
    </span>
    <app-stack-tech [stackTechs]="stackTechs" [size]="8"></app-stack-tech>
  </section>
</footer>
